import React, {useState, useMemo} from 'react';
import {withFormik, Form, Field} from "formik";
import {dataSourceV2} from "../../../../DataSource";
import TextField from "@material-ui/core/TextField";
import Button from "@material-ui/core/Button";
import FormLabel from "@material-ui/core/FormLabel";
import CircularProgress from "@material-ui/core/CircularProgress";
import MuiSelect from "../../../../MuiSelect";
import {applications} from "../../../WeHirePage";
import "./style.styl";




const sourceList = [
    {name: "Telegram", value: "telegram"},
    {name: "WhatsApp", value: "whatsapp"},
    {name: "Email", value: "email"},
    {name: "Phone", value: "phone"}
]


function ContactForm(props) {
    const {values, errors, touched, selected, isLarge, setFieldValue, isSubmitting, submitForm} = props;

    const sourceSelected = useMemo(() => sourceList.filter(v => v.value === values.contact_source_type)[0], [values.contact_source_type])
    const applicationList = useMemo(() => applications.map(v => ({name: v.position, value: v.id})), [])

    return (
        <Form>
            <div className="u-flexColumn">
                <MuiSelect      items={applicationList}
                                selected={values.application_id}
                                htmlFor={"application_id"}
                                className="u-sizeFullWidth u-marginVertical10"
                                label="Application"
                                margin={isLarge ? "normal" : "dense"}
                                onSelect={(value) => setFieldValue("application_id", value)}
                />

                <TextField
                    error={errors.name && touched.name}
                    helperText={errors.name && touched.name ? errors.name : ""}
                    label={"Your Name *"}
                    className="u-sizeFullWidth u-marginVertical10"
                    value={values.name}
                    margin={isLarge ? "normal" : "dense"}
                    onChange={(e) => setFieldValue("name", e.target.value)}
                    variant="outlined"
                />

                <TextField
                    error={errors.age && touched.age}
                    helperText={errors.age && touched.age ? errors.age : ""}
                    label={"Your Age *"}
                    type="number"
                    className="u-sizeFullWidth u-marginVertical10"
                    value={values.age}
                    margin={isLarge ? "normal" : "dense"}
                    onChange={(e) => setFieldValue("age", e.target.value)}
                    variant="outlined"
                />

                <TextField
                    error={errors.city && touched.city}
                    helperText={errors.city && touched.city ? errors.city : ""}
                    label={"Your City *"}
                    className="u-sizeFullWidth u-marginVertical10"
                    value={values.city}
                    margin={isLarge ? "normal" : "dense"}
                    onChange={(e) => setFieldValue("city", e.target.value)}
                    variant="outlined"
                />



                <MuiSelect      items={sourceList}
                                selected={values.contact_source_type}
                                htmlFor={"contact_source_type"}
                                className="u-sizeFullWidth u-marginVertical10"
                                label="Preferred Contact Source"
                                margin={isLarge ? "normal" : "dense"}
                                onSelect={(value) => setFieldValue("contact_source_type", value)}/>
                <TextField
                    error={errors.contact_source && touched.contact_source}
                    helperText={errors.contact_source && touched.contact_source ? errors.contact_source : ""}
                    label={"Your " + sourceSelected.name + " *"}
                    className="u-sizeFullWidth u-marginVertical10"
                    value={values.contact_source}
                    margin={isLarge ? "normal" : "dense"}
                    onChange={(e) => setFieldValue("contact_source", e.target.value)}
                    variant="outlined"
                />
                <TextField
                    error={errors.comments && touched.comments}
                    label="Comments"
                    helperText={errors.comments && touched.comments ? errors.comments : ""}
                    margin={isLarge ? "normal" : "dense"}
                    multiline
                    rows={2}
                    className="u-sizeFullWidth u-marginVertical10"
                    onChange={(e) => setFieldValue("comments", e.target.value)}
                    value={values.comments}
                    variant="outlined"
                />
            </div>
            <div className="u-flexCenter u-justifyContentCenter u-marginTop25">
                {
                    isSubmitting ?
                        <div>
                            <CircularProgress />
                        </div>
                        :
                        <Button variant="outlined"
                                color="primary"
                                className="u-height50 button-dark-blue"
                                disabled={isSubmitting}
                                type="submit">
                                SUBMIT
                        </Button>
                }
            </div>
        </Form>
    );
}


export default ContactForm = withFormik({
    mapPropsToValues: (props) => ({
        application_id: props.selected,
        name: "",
        age: "",
        city: "",
        contact_source_type: "telegram",
        contact_source: "",
        comments: ""
    }),

    validate: (values, props) => {
        let errors = {};
        if (!values.contact_source) {
            errors.contact_source = "Cannot be empty"
        }
        if (!values.name) {
            errors.name = "Cannot be empty"
        }
        if (!values.age) {
            errors.age = "Cannot be empty"
        }
        if (!values.city) {
            errors.city = "Cannot be empty"
        }

        return errors
    },

    handleSubmit: (values, props) => {
        const {onSubmit} = props.props;

        const data = {
            service_id: 'wescaleweb',
            template_id: 'application',
            user_id: 'user_zaw1C1DQepfSsNOI0hq9q',
            template_params: {
                "name": values.name,
                "age": values.email,
                "data": JSON.stringify(values)
            }
        };
        dataSourceV2(`api/v1.0/email/send`, {data, url: "https://api.emailjs.com"})
            .then(v=>{
                props.setSubmitting(false);
                props.resetForm();
                onSubmit();
            })
    },

})(ContactForm);
